var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn brand-dark-bg text-white btn-width-110",attrs:{"data-turbolinks":"false"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v("Submit")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }